export default __webpack_public_path__ + "static/media/9.c4f71b14.jpeg";